import { ETargetType, IModalDetails } from '../types/phoneWarning';

export const PHONE_WARNING_MODAL_DETAILS: Record<ETargetType, IModalDetails> = {
  [ETargetType.Booking]: {
    content: 'Чтобы забронировать квартиру, добавьте номер телефона',
    title: 'Не хватает номера телефона',
  },
};
